import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const Information = () => {
  const { t } = useTranslation();

  return (
    <>
      <section className="information-section">
        <div className="first-para">
          <h2>
            XProtocol: Your Phone. Your Network. <span></span>
          </h2>
          <p>XProtocol is an EVM blockchain backed by Saison Capital, Cogitent Ventures, Founderheads, Razer and Dragonfly. XForge is the first node-operated blockchain smartphone powered by XProtocol, enabling everyday users to earn passive rewards and seamlessly participate in the DePIN and on-chain ecosystem.</p>
          <p>Partners:</p>
          <ol>
            <li>XTrade - the ultimate on-chain platform for perps and spot trading powered by Hyperliquid and Solana, incubated by XForge.</li>
            <li>XYO - The original DePIN project with the first scalable blockchain built for data.</li>
            <li>Aethir - T1 DePIN project, $150 million raised, 1+ million community & 25k node runners.</li>
            <li>Huddle01 - The ultra-low latency network powering real-time AI and communications.</li>
            <li>Wonderverse - Open-ended Idle RPG built on top of XProtocol, incubated by Seedify.</li>
            <li>Intract - 12 million users, $200 million USD of rewards claimed & 7000+ partners.</li>
            <li>Dverse - Clients: Algorand, Farcana & Binance among others.</li>
          </ol>
          <p>Together, these partners form a growing on-chain ecosystem, positioning XProtocol and XForge as the gateway for passive digital income, network participation, and everyday on-chain utility for the next million users.</p>
        </div>
        <div className="first-para">
          <h2>
            What Makes XProtocol Unique? <span></span>
          </h2>
          <ol>
            <li>1.5 Million+ unique users.</li>
            <li>10,000+ active nodes and 4,000+ DePIN smartphone devices sold.</li>
            <li>Airdrops from partner projects - including XTrade, the on-chain trading terminal incubated by XForge.</li>
            <li>DePIN Chain: built for unmatched scalability, with throughput potential to exceed 1,000+ TPS.</li>
            <li>Ultra-low transaction costs, reducing gas fees to millionths of a cent.</li>
          </ol>
        </div>
        <div className="first-para">
          <h2>
            GO-TO-MARKET STRATEGY <span></span>
          </h2>
          <p>XProtocol’s go-to-market strategy bridges Web2 distribution with Web3 incentives to drive mass adoption of decentralized infrastructure.</p>
          <h6>1. Web2 Distribution Channels:</h6>
          <p>XForge smartphones powered by XProtocol will be distributed through traditional e-commerce and retail networks. This ensures accessibility through familiar purchasing channels while bundling built-in on-chain functionality for first-time users.</p>
          <h6>2. Partnership Ecosystem:</h6>
          <p>Strategic collaborations with DeFi protocols, infrastructure partners, and consumer tech brands strengthen both reach and utility. Partnerships with projects like XTrade, liquidity networks, and hardware integrators expand interoperability and reward opportunities for users.</p>
          <h6>3. User Incentives and Growth Loops:</h6>
          <p>XForge owners earn passive rewards by participating in network coordination activities, creating viral growth through social referral programs, XP systems, and gamified achievements designed to enhance retention and engagement.</p>
          <h6>4. Regional Focus and Community Activation:</h6>
          <p>Initial rollouts will target high-growth markets across Southeast Asia and emerging economies with strong mobile penetration but limited Web3 exposure. Localized marketing campaigns, community events, and partnerships with KOLs will drive education and adoption.</p>
        </div>
        <div className="first-para">
          <h2>
            Investors <span></span>
          </h2>
          <p>XProtocol is supported by a distinguished group of Tier 1 investors, bringing a wealth of experience and strategic insights, significantly contributing to XProtocol's growth and success.</p>
          <h6>Saison Capital</h6>
          <p>Saison Capital is a global venture capital firm with a focus on early-stage investments in fintech and emerging technologies. Backed by Credit Saison, one of Japan's largest financial institutions, Saison Capital leverages deep industry expertise and a strong network to support startups in achieving scalable growth. Notable crypto projects they have backed include Mythic Protocol, Blackwing, and Anime Metaverse.</p>
          <h6>Dragonfly</h6>
          <p>Specializing in blockchain investments, Dragonfly Capital has supported notable projects such as Ethena, Avalanche and MakerDAO. Their expertise in the crypto space is crucial for XProtocol’s technological development and market expansion.</p>
          <h6>Zephyrus Capital</h6>
          <p>Focusing on transformative technologies, Zephyrus Capital has supported projects like Polkadot. Their confidence in XProtocol's vision is a significant endorsement</p>
          <h6>Coinfund</h6>
          <p>Coinfund is a pioneering investment firm dedicated to the blockchain and cryptocurrency space. With a strong emphasis on decentralization and innovative financial solutions, Coinfund backs projects that aim to reshape the digital economy. The firm is known for its deep technical expertise and strong community ties within the crypto ecosystem.</p>
          <h6>MSA</h6>
          <p>MSA Capital is a leading venture capital firm investing in growth-stage companies across China and global markets. With a diverse portfolio spanning healthcare, AI, and consumer internet sectors, MSA Capital leverages its extensive network and market insights to drive growth and innovation.</p>
          <h6>Cogitent Ventures</h6>
          <p>Cogitent Ventures focuses on early-stage investments in tech startups with high growth potential. Known for its data-driven investment approach, Cogitent Ventures supports entrepreneurs with strategic advice, industry connections, and operational expertise to accelerate their business growth.</p>
          <h6>Razer</h6>
          <p>Razer, a well-known brand in gaming hardware and software, also operates an investment arm targeting startups in the gaming, esports, and fintech sectors. Leveraging its strong brand and industry knowledge, Razer provides strategic investments and partnerships to foster innovation and growth in the gaming ecosystem.</p>
          <h6>Caballeros Capital</h6>
          <p>Caballeros Capital is a venture capital firm that invests in early to growth-stage technology companies. With a focus on innovation and sustainable growth, Caballeros Capital offers a combination of financial backing, strategic guidance, and access to a broad network of industry leaders to help startups succeed.</p>
        </div>
        <div className="first-para">
          <h2>
            TOKENOMICS <span></span>
          </h2>
        </div>
        <div className="first-para">
          <div className="twice-tokenomics">
            <div className="tokenomic-img">
              <img src="\assets\alldetailpages\xprotocol\info\graph.png" alt="img" className='img-fluid hide-in-light-theme' />
              <img src="\assets\alldetailpages\xprotocol\info\graphlight.png" alt="img" className='img-fluid d-none show-in-light-theme ' />
            </div>
          </div>
        </div>
        <div className="first-para">
          <h2>
            {t('Inc-detailt34')} <span></span>
          </h2>
          <div className="team-gems">
            <div className="single-team">
              <img
                src="\assets\alldetailpages\xprotocol\info\team\1.png"
                alt="img"
                className="img-fluid"
              />
              <h6 className="mb-0">Peter Huang </h6>
              <h5>Co-founder and Core Contributor</h5>
              <p>Peter brings extensive experience from co-founding Gotrade, a Y Combinator-backed platform often referred to as the "Robinhood for Asia," and leading a successful cross-platform mobile gaming studio. His deep knowledge of gaming and fintech uniquely positions him to drive XProtocol’s vision in the Web3 entertainment space.</p>
            </div>
            <div className="single-team">
              <img
                src="\assets\alldetailpages\xprotocol\info\team\2.png"
                alt="img"
                className="img-fluid"
              />
              <h6 className="mb-0">Dmitriy Paunin </h6>
              <h5> Co-founder and Core Contributor</h5>
              <p> Dmitriy is a seasoned IT professional with expertise across all facets of development. As a former CTO in three ventures, he spearheaded technical operations at coins.ph, one of the largest fiat and crypto e-wallets in the Southeast Asia.</p>
            </div>
            <div className="single-team">
              <img
                src="\assets\alldetailpages\xprotocol\info\team\3.png"
                alt="img"
                className="img-fluid"
              />
              <h6 className="mb-0">Sky Wee </h6>
              <h5>Strategy and Business Development</h5>
              <p>Sky Wee is a gaming influencer with 4+ million followers and Forbes Business Council member, Binance Official Influencer</p>

            </div>
          </div>
        </div>
      </section>


    </>
  );
};

export default Information;